import { useAuthStore } from './lib/authStore';
import { LoginScreen } from './features/login/LoginScreen';
import { SetupScreen } from './features/login/SetupScreen';
import { AppShell } from './features/shell/AppShell';

export function App(): JSX.Element {
  const stage = useAuthStore((s) => s.stage);
  const adopting = useAuthStore((s) => s.adopting);
  const setup = useAuthStore((s) => s.setup);

  if (adopting) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100 text-sm text-slate-500 dark:bg-slate-950 dark:text-slate-400">
        Signing you in…
      </div>
    );
  }
  if (setup) return <SetupScreen />;
  return stage === 'session' ? <AppShell /> : <LoginScreen />;
}
